import React from "react";
import { Hero } from "../components/sections/Hero";
import { Problem } from "../components/sections/Problem";
import { BeforeAfter } from "../components/sections/BeforeAfter";
import { PainPoints } from "../components/sections/PainPoints";
import { Volumes } from "../components/sections/Volumes";
import { Tools } from "../components/sections/Tools";
import { Bonuses } from "../components/sections/Bonuses";
import { Testimonials } from "../components/sections/Testimonials";
import { Offer } from "../components/sections/Offer";
import { Guarantee } from "../components/sections/Guarantee";
import { Author } from "../components/sections/Author";
import { Faq } from "../components/sections/Faq";
import { FinalCta } from "../components/sections/FinalCta";
import { FloatingCta } from "../components/FloatingCta";
import { PurchasePopup } from "../components/PurchasePopup";
export function SalesPage() {
  return <div className="w-full overflow-x-hidden bg-paper font-sans text-ink" data-id="element-309" data-mp="3vo2yn6pi40kp">
      <Hero data-id="element-310" data-mp="3ak8a00mvf5kj" />
      <main data-id="element-311" data-mp="3akrv1q7tia2s">
        <Problem data-id="element-312" data-mp="3aki1jsnkdksc" />
        <BeforeAfter data-id="element-313" data-mp="3al1eeuycxizi" />
        <PainPoints data-id="element-314" data-mp="35t02ja53pua0" />
        <Volumes data-id="element-315" data-mp="35shwxmwju3pf" />
        <Tools data-id="element-316" data-mp="35ryqb2ccn1qp" />
        <Bonuses data-id="element-317" data-mp="35rf9joyfqje9" />
        <Testimonials data-id="element-318" data-mp="35qx2rye5cms3" />
        <Offer data-id="element-319" data-mp="30twztwclg057" />
        <Guarantee data-id="element-320" data-mp="30tdqv54x8m3b" />
        <Author data-id="element-321" data-mp="30uyhwks11mwf" />
        <Faq data-id="element-322" data-mp="30ugd2zrau0cw" />
        <FinalCta data-id="element-323" data-mp="30ru9fb7j44zy" />
      </main>
      <FloatingCta data-id="element-324" data-mp="2vv3uwsbdhhgn" />
      <PurchasePopup data-id="element-325" data-mp="2vvlpzlmatpmz" />
    </div>;
}